<div class="button-toggle-container">
    <span class="mat-caption">{{ labelT | translate }}</span>
    <mat-button-toggle-group [formControlName]="controlKey" class="status-toggle">
        <mat-button-toggle [value]="value1">
            {{ label1T | translate }}
        </mat-button-toggle>
        <mat-button-toggle [value]="value2">
            {{ label2T | translate }}
        </mat-button-toggle>
    </mat-button-toggle-group>
</div>